import React, { useEffect, useState} from "react";
import Header from "../components/Header";
import { Link, useLocation ,useParams  } from "react-router-dom";
import Product1 from "../components/Product1";
import Sheet from 'react-modal-sheet';
import { BsSliders, BsCaretDownFill, BsArrowClockwise } from "react-icons/bs";

import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import { useAxios } from "../services/useAxios";
import { useTranslation } from 'react-i18next';


export default function Categories() {
    const { t } = useTranslation();
    const [isOpen, setOpen] = useState(false);

    const location = useLocation();	
    const [cate, setCate] = useState({});
   
    let {id} = useParams();
    const [selectCate, setSelectCate] = useState(id);
    const [data, setData] = useState({});
    const [selectOrder, setSelectOrder] = useState('popular');
    const lang = localStorage.getItem("language") || "ko";
    const [request] = useAxios();

    const [page, setPage] = useState({
        current: 1, // 현재 페이지
        total: 0,   // 전체 페이지
      });
    
    // 페이지 값을 인자로 받아 페이지 정보를 변경 
      function setPageInfo (currentPage) {
          setPage({
            ...page,
            current: currentPage,
          });

          fetchData(currentPage);
      }

      

    const fn_clTab = (obj) => {
    
        if(obj!==null){
            setSelectCate(obj.goodsClSn);
        }else{
            setSelectCate(id);
        }
        
    } 
    
    const handleSelect = (e) => {
        setSelectOrder(e.target.value);
    };
    const fetchData2 = async () => {
        const response = await request.post("/app/goods/getGoodsClListAPI", {
            nationSeCode : lang,
            goodsClSn : id,
        });

        if(response.data.resultCode === 200){
            //console.log(response.data.result);
            setCate(response.data.result);
        }
    };

    const fetchData = async (pageIndex) => {
        console.log(selectCate)
        const response = await request.post("/app/goods/getGoodsListAPI", {
            nationSeCode : lang,
            goodsClSn : selectCate,
            orderBy : selectOrder,
            pageIndex : pageIndex

        });
        if(response.data.resultCode === 200){
            console.log(response.data.result);
            
            if(pageIndex === 1){
                setData(response.data.result);
            }else{
                if(data.resultList){
                    response.data.result.resultList = data.resultList.concat(response.data.result.resultList);
                    setData(response.data.result);
                }
            }

            setPage({
                current : pageIndex,
                total: Number(data.resultCnt),
              });
        }            
    };

    useEffect(() => {
        fetchData2();
        fetchData(1);
      }, [selectCate, selectOrder]);

      

    return(
        <div>
            <div className="backGround bgBlue"></div>
            <div className="headFixed backGround bgBlue">
                <Header type="cart" pageTitle={cate?.goodsClVO?.goodsClNm}/>
                <div className="tabArea">
                    <div className={selectCate===id ?'tabBtn active':'tabBtn'} onClick ={() => fn_clTab(null)}>{t(`Message.common_all`)}</div>
                    {cate.goodsClList && cate.goodsClList.map((obj, index) => (
                    <div className={selectCate===obj.goodsClSn ?'tabBtn active':'tabBtn'} key={index} onClick ={() => fn_clTab(obj)}>{obj.goodsClNm}</div>
                     ))}                       
                </div>
            </div>

            <div className="categoriesWr">
                <div className="fliterWr">
                    <button 
                        type="button" 
                        className="filterBtn"
                        onClick={(e) => {
                            e.preventDefault(); 
                            e.stopPropagation(); 
                            setOpen(true);
                        }}
                    >
                        <BsSliders />
                        <span>{t(`Message.goods_list_screen_filter_btn`)}</span>
                    </button>
                    <select onChange={handleSelect} className="sort">
                        <option value="popular">{t(`Message.goods_list_screen_ordr_popular`)}</option>
                        <option value="recent">{t(`Message.goods_list_screen_ordr_recent`)}</option>
                        <option value="lowPrice">{t(`Message.goods_list_screen_ordr_lowPrice`)}</option>
                        <option value="highPrice">{t(`Message.goods_list_screen_ordr_highPrice`)}</option>
                        <option value="order">{t(`Message.goods_list_screen_ordr_order`)}</option>
                        <option value="review">{t(`Message.goods_list_screen_ordr_review`)}</option>
                    </select>
                </div>
                <div className="ct2">
                {data.resultList && data.resultList.map((obj, index) => (
                
                
                <Product1 key={index}
                    img={"https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn="+obj.goodsImageSn}
                    type="type2"
                    prodName={obj.goodsNm}
                    disprice={obj.sleAmount.toLocaleString('ko-KR')}
                    percent={obj.dscntRate * 100}
                    cost={obj.nrmltAmount.toLocaleString('ko-KR')}
                    heart={true}
                    cart={true}
                    obj = {obj}
                />
                ))}       
                </div>  
                {data.resultList && page.total !== data.resultList.length?
                <div className="moreBtnWr">
                    <button type="button" className="more" onClick={() => setPageInfo(page.current + 1)}>{t(`Message.더보기`)}</button>
                </div>
                :''}
                
            </div>





            <Sheet isOpen={isOpen} onClose={() => setOpen(false)} className="bottomModal">
                <Sheet.Container>
                <Sheet.Header />
                <Sheet.Content>
                    <div className="dfColG16 btModalArea">
                        <div className="dfsb">
                            <h3 className="btModalTit">{t(`Message.goods_list_screen_filter_btn`)}</h3>
                            <button type="button" className="btn24 cFFF greenB dfcsG4 fs13"><BsArrowClockwise /> {t(`Message.goods_list_screen_init_btn`)}</button>
                        </div>
                        <Tabs
                            id="controlled-tab-example"
                            defaultActiveKey="tab1"
                            className="tabType1"
                            >
                            <Tab eventKey="tab1" title="배송">
                                <div className="modalTabWr">
                                    <ul className="chkWr dfColG12">
                                        <li>
                                            <input type="checkbox" name="a" id="a1" />
                                            <label htmlFor="a1">{t(`Message.goods_list_screen_filter_free_dlvy`)}</label>
                                        </li>
                                        <li>
                                            <input type="checkbox" name="a" id="a2" />
                                            <label htmlFor="a2">{t(`Message.goods_list_screen_filter_same_day_dlvy`)}</label>
                                        </li>
                                    </ul>
                                </div>
                            </Tab>
                            <Tab eventKey="tab2" title={t(`Message.goods_list_screen_filter_tab2`)}>
                                <div className="modalTabWr">
                                    <ul className="chkWr dfColG12">
                                    {data.goodsInfoBrandList && data.goodsInfoBrandList.map((obj, index) => (
                                        <li key={index}>
                                            <input type="checkbox" name="b" id="b1"  />
                                            <label htmlFor="b1">{obj.brandNm}</label>
                                        </li>
                                    ))}                                            
                                    </ul>
                                </div>
                            </Tab>
                            <Tab eventKey="tab3" title={t(`Message.goods_list_screen_filter_tab3`)}>
                                <div className="modalTabWr">
                                    <div className="dfcsG6">
                                        <input type="number" name="" id="" placeholder={t(`Message.goods_list_screen_filter_lowprice`)}/>
                                        <span>~</span>
                                        <input type="number" placeholder={t(`Message.goods_list_screen_filter_highprice`)}/>
                                    </div>
                                </div>
                            </Tab>
                        </Tabs> 
                    </div>
                    <div className="btnWr">
                        <button type="button" className="btn40 wgB cDisa" onClick={() => setOpen(false)}>취소</button>
                        <button type="button" className="btn40 orgB cFFF">{t(`Message.goods_list_screen_filter_search_btn`)}</button>
                    </div>
                </Sheet.Content>
                </Sheet.Container>
                <Sheet.Backdrop onClick={() => setOpen(false)}/>
            </Sheet>
        </div>
    )
}